export * from './BannerAsProductTile';
